export const reportsTranslations = {
  ar: {
    detailedSalesReport: 'تقرير المبيعات التفصيلي',
    salesReport: 'تقرير المبيعات',
    comparisonReport: 'تقرير المقارنة',
    vatReturn: 'إقرار ضريبي',
    dailyMaterialsMovement: 'حركة المواد اليومية',
    posInvoiceDesign: 'تصميم فاتورة نقطة البيع',
    posInvoiceDesignDescription: 'صفحة تصميم فاتورة نقطة البيع',
    yearOverYear: 'مقارنة سنة مقابل سنة',
    branchComparison: 'مقارنة الفروع',
    current: 'الحالي',
    change: 'التغيير',
    increase: 'زيادة',
    decrease: 'نقصان',
    selectYear: 'اختر السنة',
    selectMonth: 'اختر الشهر',
    selectBranch1: 'اختر الفرع الأول',
    selectBranch2: 'اختر الفرع الثاني',
    salesReturns: 'المرتجع مبيع',
    calculate: 'إعادة الحساب',
    submit: 'إرسال الإقرار',
    calculating: 'جاري الحساب...',
    submitSuccess: 'تم إرسال الإقرار بنجاح',
    submitError: 'فشل إرسال الإقرار',
    confirmSubmit: 'هل أنت متأكد من إرسال هذا الإقرار؟',
    period: 'الفترة الضريبية',
    periodSelection: 'اختيار الفترة',
    quarter: 'ربع سنوي',
    annual: 'سنوي',
    custom: 'مخصص',
    q1: 'الربع الأول',
    q2: 'الربع الثاني',
    q3: 'الربع الثالث',
    q4: 'الربع الرابع',
    year: 'السنة',
    allBranches: 'جميع الأفرع',
    draft: 'مسودة',
    submitted: 'مُرسل',
    accepted: 'مقبول',
    rejected: 'مرفوض',
    returnNumber: 'رقم الإقرار',
    submitDate: 'تاريخ الإرسال',
    totalSalesAmount: 'إجمالي المبيعات الخاضعة للضريبة',
    outputVat: 'ضريبة المبيعات (Output VAT)',
    invoiceCount: 'عدد الفواتير',
    totalPurchasesAmount: 'إجمالي المشتريات الخاضعة للضريبة',
    inputVat: 'ضريبة المشتريات (Input VAT)',
    purchaseInvoiceCount: 'عدد فواتير المشتريات',
    netVat: 'الضريبة الصافية المستحقة',
    vatOnPurchases: 'ضريبة القيمة المضافة على المشتريات',
    purchaseDetails: 'تفاصيل المشتريات',
    totals: 'الإجماليات',
    totalInvoices: 'عدد الفواتير',
    totalQuantity: 'إجمالي الكمية',
    totalAmount: 'إجمالي المبلغ',
    invoiceType: 'نوع الفاتورة',
    paymentType: 'نوع الدفع',
    customerName: 'اسم العميل',
    invoiceTotal: 'إجمالي الفاتورة',
    group: 'المجموعة',
    code: 'الرمز',
    material: 'المادة',
    contains: 'يحتوى',
    costCenter: 'مركز الكلفة',
    currency: 'العملة',
    branches: 'الأفرع',
    invoiceTypes: 'أنواع الفواتير',
    preview: 'معاينة',
    basicRatePurchases: 'المشتريات الخاضعة للنسبة الأساسية',
    basicRateImports: 'الاستيرادات الخاضعة للقيمة المضافة بالنسبة الأساسية',
    expenses: 'المصاريف',
    reverseChargeImports: 'الاستيرادات الخاضعة للقيمة المضافة التي تطبق عليها آلية الاحتساب العكسي',
    exemptPurchases: 'المشتريات المعفاة',
    totalPurchases: 'إجمالي المشتريات',
    vatOnSales: 'ضريبة القيمة المضافة على المبيعات',
    gridView: 'عرض الشبكة',
    listView: 'عرض القائمة',
    searchTerm: 'كلمة البحث',
    serial: 'الرقم التسلسلي',
    userRefNo: 'الرقم المرجعي',
    taxType: 'نوع الضريبة',
    all: 'الكل',
    taxInclusive: 'شامل الضريبة',
    taxExclusive: 'غير شامل الضريبة',
    groupBy: 'التجميع حسب',
    groupByNone: 'بدون تجميع',
    groupByInvoice: 'حسب الفاتورة',
    groupByCustomer: 'حسب العميل',
    groupByItem: 'حسب الصنف',
    groupByDate: 'حسب التاريخ',
    groupByBranch: 'حسب الفرع',
    apply: 'تطبيق',
    totalSubTotal: 'إجمالي المبلغ الفرعي',
    totalDiscount: 'إجمالي الخصم',
    totalTax: 'إجمالي الضريبة',
    totalGrossAmount: 'إجمالي المبلغ الإجمالي',
    invoice: 'الفاتورة',
    itemDetails: 'تفاصيل الصنف',
    unitPrice: 'سعر الوحدة',
    subtotal: 'المبلغ الفرعي',
    discount: 'الخصم',
    tax: 'الضريبة',
    netAmount: 'المبلغ الصافي',
    paymentMethod: 'طريقة الدفع',
    status: 'الحالة',
    itemName: 'اسم الصنف',
    printDate: 'تاريخ الطباعة:',
    printedBy: 'طبع بواسطة:',
    defaultCompanyName: 'نظام الإدارة المالية',
  },
  en: {
    detailedSalesReport: 'Detailed Sales Report',
    salesReport: 'Sales Report',
    comparisonReport: 'Comparison Report',
    vatReturn: 'VAT Return',
    dailyMaterialsMovement: 'Daily Materials Movement',
    posInvoiceDesign: 'POS Invoice Design',
    posInvoiceDesignDescription: 'POS Invoice Design Page',
    yearOverYear: 'Year over Year Comparison',
    branchComparison: 'Branch Comparison',
    current: 'Current',
    change: 'Change',
    increase: 'Increase',
    decrease: 'Decrease',
    selectYear: 'Select Year',
    selectMonth: 'Select Month',
    selectBranch1: 'Select First Branch',
    selectBranch2: 'Select Second Branch',
    salesReturns: 'Sales Returns',
    calculate: 'Calculate',
    submit: 'Submit Return',
    calculating: 'Calculating...',
    submitSuccess: 'Return submitted successfully',
    submitError: 'Failed to submit return',
    confirmSubmit: 'Are you sure you want to submit this return?',
    period: 'Tax Period',
    periodSelection: 'Period Selection',
    quarter: 'Quarterly',
    annual: 'Annual',
    custom: 'Custom',
    q1: 'Q1',
    q2: 'Q2',
    q3: 'Q3',
    q4: 'Q4',
    year: 'Year',
    allBranches: 'All Branches',
    draft: 'Draft',
    submitted: 'Submitted',
    accepted: 'Accepted',
    rejected: 'Rejected',
    returnNumber: 'Return Number',
    submitDate: 'Submit Date',
    totalSalesAmount: 'Total Taxable Sales',
    outputVat: 'Output VAT',
    invoiceCount: 'Invoice Count',
    totalPurchasesAmount: 'Total Taxable Purchases',
    inputVat: 'Input VAT',
    purchaseInvoiceCount: 'Purchase Invoice Count',
    netVat: 'Net VAT Due',
    vatOnPurchases: 'VAT on Purchases',
    purchaseDetails: 'Purchase Details',
    totals: 'Totals',
    totalInvoices: 'Total Invoices',
    totalQuantity: 'Total Quantity',
    totalAmount: 'Total Amount',
    invoiceType: 'Invoice Type',
    paymentType: 'Payment Type',
    customerName: 'Customer Name',
    invoiceTotal: 'Invoice Total',
    group: 'Group',
    code: 'Code',
    material: 'Material',
    contains: 'Contains',
    costCenter: 'Cost Center',
    currency: 'Currency',
    branches: 'Branches',
    invoiceTypes: 'Invoice Types',
    preview: 'Preview',
    basicRatePurchases: 'Standard Rate Purchases',
    basicRateImports: 'Standard Rate Imports',
    expenses: 'Expenses',
    reverseChargeImports: 'Reverse Charge Imports',
    exemptPurchases: 'Exempt Purchases',
    totalPurchases: 'Total Purchases',
    vatOnSales: 'VAT on Sales',
    gridView: 'Grid View',
    listView: 'List View',
    searchTerm: 'Search Term',
    serial: 'Serial',
    userRefNo: 'Ref No',
    taxType: 'Tax Type',
    all: 'All',
    taxInclusive: 'Tax Inclusive',
    taxExclusive: 'Tax Exclusive',
    groupBy: 'Group By',
    groupByNone: 'No Grouping',
    groupByInvoice: 'By Invoice',
    groupByCustomer: 'By Customer',
    groupByItem: 'By Item',
    groupByDate: 'By Date',
    groupByBranch: 'By Branch',
    apply: 'Apply',
    totalSubTotal: 'Total Subtotal',
    totalDiscount: 'Total Discount',
    totalTax: 'Total Tax',
    totalGrossAmount: 'Total Gross Amount',
    invoice: 'Invoice',
    itemDetails: 'Item Details',
    unitPrice: 'Unit Price',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    netAmount: 'Net Amount',
    paymentMethod: 'Payment Method',
    status: 'Status',
    itemName: 'Item Name',
    printDate: 'Print Date:',
    printedBy: 'Printed by:',
    defaultCompanyName: 'Financial Management System',
  },
  fr: {
    detailedSalesReport: 'Rapport de ventes détaillé',
    salesReport: 'Rapport de ventes',
    comparisonReport: 'Rapport de comparaison',
    vatReturn: 'Déclaration de TVA',
    dailyMaterialsMovement: 'Mouvement quotidien des matériaux',
    posInvoiceDesign: 'Conception de facture PDV',
    posInvoiceDesignDescription: 'Page de conception de facture PDV',
    yearOverYear: 'Comparaison année sur année',
    branchComparison: 'Comparaison des succursales',
    current: 'Actuel',
    change: 'Changement',
    increase: 'Augmentation',
    decrease: 'Diminution',
    selectYear: 'Sélectionner l\'année',
    selectMonth: 'Sélectionner le mois',
    selectBranch1: 'Sélectionner la première succursale',
    selectBranch2: 'Sélectionner la deuxième succursale',
    salesReturns: 'Retours de ventes',
    calculate: 'Recalculer',
    submit: 'Soumettre la déclaration',
    calculating: 'Calcul en cours...',
    submitSuccess: 'Déclaration soumise avec succès',
    submitError: 'Échec de la soumission de la déclaration',
    confirmSubmit: 'Êtes-vous sûr de vouloir soumettre cette déclaration ?',
    period: 'Période fiscale',
    periodSelection: 'Sélection de la période',
    quarter: 'Trimestriel',
    annual: 'Annuel',
    custom: 'Personnalisé',
    q1: 'T1',
    q2: 'T2',
    q3: 'T3',
    q4: 'T4',
    year: 'Année',
    allBranches: 'Toutes les succursales',
    draft: 'Brouillon',
    submitted: 'Soumis',
    accepted: 'Accepté',
    rejected: 'Rejeté',
    returnNumber: 'Numéro de déclaration',
    submitDate: 'Date de soumission',
    totalSalesAmount: 'Total des ventes imposables',
    outputVat: 'TVA à la sortie',
    invoiceCount: 'Nombre de factures',
    totalPurchasesAmount: 'Total des achats imposables',
    inputVat: 'TVA à l\'entrée',
    purchaseInvoiceCount: 'Nombre de factures d\'achat',
    netVat: 'TVA nette due',
    vatOnPurchases: 'TVA sur les achats',
    purchaseDetails: 'Détails des achats',
    totals: 'Totaux',
    totalInvoices: 'Nombre total de factures',
    totalQuantity: 'Quantité totale',
    totalAmount: 'Montant total',
    invoiceType: 'Type de facture',
    paymentType: 'Type de paiement',
    customerName: 'Nom du client',
    invoiceTotal: 'Total de la facture',
    group: 'Groupe',
    code: 'Code',
    material: 'Matériau',
    contains: 'Contient',
    costCenter: 'Centre de coûts',
    currency: 'Devise',
    branches: 'Succursales',
    invoiceTypes: 'Types de factures',
    preview: 'Aperçu',
    basicRatePurchases: 'Achats soumis au taux de base',
    basicRateImports: 'Importations soumises à la TVA au taux de base',
    expenses: 'Dépenses',
    reverseChargeImports: 'Importations soumises à la TVA avec mécanisme de charge inversée',
    exemptPurchases: 'Achats exonérés',
    totalPurchases: 'Total des achats',
    vatOnSales: 'TVA sur les ventes',
    gridView: 'Vue en grille',
    listView: 'Vue en liste',
    searchTerm: 'Terme de recherche',
    serial: 'Série',
    userRefNo: 'Numéro de référence',
    taxType: 'Type de taxe',
    all: 'Tout',
    taxInclusive: 'Taxe incluse',
    taxExclusive: 'Taxe exclue',
    groupBy: 'Grouper par',
    groupByNone: 'Aucun regroupement',
    groupByInvoice: 'Par facture',
    groupByCustomer: 'Par client',
    groupByItem: 'Par article',
    groupByDate: 'Par date',
    groupByBranch: 'Par succursale',
    apply: 'Appliquer',
    totalSubTotal: 'Total sous-total',
    totalDiscount: 'Total remise',
    totalTax: 'Total taxe',
    totalGrossAmount: 'Montant brut total',
    invoice: 'Facture',
    itemDetails: 'Détails de l\'article',
    unitPrice: 'Prix unitaire',
    subtotal: 'Sous-total',
    discount: 'Remise',
    tax: 'Taxe',
    netAmount: 'Montant net',
    paymentMethod: 'Méthode de paiement',
    status: 'Statut',
    itemName: 'Nom de l\'article',
  },
};
